export const webSocektUrl = 'xgapi.coalsmine.com'